import * as React from "react";
import {ITaste} from "../../../models/taste";
import { RouteComponentProps, withRouter } from "react-router-dom";
import {getSession, setSession} from "../../../session";
import {ISetting} from "../../../models/setting";
import TasteImages, { ITasteImageModal } from "../detail/taste_images";

interface IOuterProps {
  id: number;
  title: string;
  imageUrl?: string;
  isRecommend?: boolean;
  select_case_ids: number[];
  index: number;
  taste: ITaste;
  user_made_images: any;
  onClickThumbnail?: (index: number) => void;
}

type AllProps = IOuterProps & RouteComponentProps;

const TasteCell = (props: AllProps) => {
  const { title, imageUrl, isRecommend } = props;

    const session = getSession();
    let visualizationStatus: boolean = false;
    if (session && session.visualization_func_status && props.taste !== null && props.taste.base_images !== null) {
        const image_url_01: boolean = props.taste.base_images.image_url_01 !== null && props.taste.base_images.image_url_01 !== '';
        const image_url_02: boolean = props.taste.base_images.image_url_02 !== null && props.taste.base_images.image_url_02 !== '';
        const spotlight_url_01: boolean = props.taste.base_images.spotlight_url_01 !== null && props.taste.base_images.spotlight_url_01 !== '';
        const spotlight_url_02: boolean = props.taste.base_images.spotlight_url_02 !== null && props.taste.base_images.spotlight_url_02 !== '';
        if (image_url_01 && image_url_02 && spotlight_url_01 && spotlight_url_02) {
            visualizationStatus = true;
        }
    }
    if (visualizationStatus) {
        return (
            <React.Fragment>
                <div className="c-card-thumbnail">
                    <div
                        className="c-thumbnail--round_top"
                        style={{width: "100%"}}
                        data-object_fit="contain"
                        onClick={() => {
                            let session = getSession();
                            if (session != null) {
                                session.from_where = `${window.location.pathname + window.location.search}`
                                setSession(session);
                            }
                            props.history.push(
                                `/taste/detail/${props.id}/?select_case_ids=${props.select_case_ids}`
                            );
                        }}
                    >
                        <img
                            src={
                                imageUrl === ""
                                    ? "https://d1kj7933n1tx2w.cloudfront.net/images/rooms/icon_image_default.png"
                                    : imageUrl
                            }
                            alt="画像が設定されていません"
                        />
                    </div>
                </div>
                {/* カバーサムネイル */}
                <TasteCoverThumbnailsForVisualizationFunc
                    {...props}
                    user_made_images={props.user_made_images}
                    taste={props.taste}
                    index={props.index}
                />
                {isRecommend ? (
                    <div className="c-card-ribbon">
                        <div className="c-ribbon u-fc--tint u-tc--on_tint"> オススメ</div>
                    </div>
                ) : null}
                <div className="c-card-body">
                    {" "}
                    <div className="c-card-body-title">{title}</div>
                </div>
                <TasteImageModal taste_id={props.taste.id} urls={props.taste.images} startIndex={0} />
            </React.Fragment>
        );
    }else{
        return (
            <React.Fragment>
                <div className="c-card-thumbnail">
                    <div
                        className="c-thumbnail--round_top"
                        style={{width: "100%"}}
                        data-object_fit="contain"
                        onClick={() => {
                            let session = getSession();
                            if (session != null) {
                                session.from_where = `${window.location.pathname + window.location.search}`
                                setSession(session);
                            }
                            props.history.push(
                                `/taste/detail/${props.id}/?select_case_ids=${props.select_case_ids}`
                            );
                        }}
                    >
                        <img
                            src={
                                imageUrl === ""
                                    ? "https://d1kj7933n1tx2w.cloudfront.net/images/rooms/icon_image_default.png"
                                    : imageUrl
                            }
                            alt="画像が設定されていません"
                        />
                    </div>
                </div>
                {/* カバーサムネイル */}
                <TasteCoverThumbnails
                    {...props}
                    taste={props.taste}
                    index={props.index}
                />
                {isRecommend ? (
                    <div className="c-card-ribbon">
                        <div className="c-ribbon u-fc--tint u-tc--on_tint"> オススメ</div>
                    </div>
                ) : null}
                <div className="c-card-body">
                    {" "}
                    <div className="c-card-body-title">{title}</div>
                </div>
            </React.Fragment>
        );
    }
};

interface ISettingOuterProps {
    setting?: ISetting;
}

const TasteCoverThumbnailsForVisualizationFunc = (props: AllProps & ISettingOuterProps) => {
    const { onClickThumbnail } = props;
    const testImages = props.taste.images;

    if (props.user_made_images !== "No-images") {
        if (props.user_made_images.image_url_02 !== null && !testImages.includes(props.user_made_images.image_url_02)) {
            testImages.unshift(props.user_made_images.image_url_02);
        }
        if (props.user_made_images.image_url_01 !== null && !testImages.includes(props.user_made_images.image_url_01)) {
            testImages.unshift(props.user_made_images.image_url_01);
        }
    }
    return (
        <div className="c-group--taste_details-thumb_list">
            <div className="c-list--equal" data-list_column="4">
                {testImages.length > 0 && testImages.slice(1).map((url, index) => {
                    const u = encodeURI(url);
                    return (
                        <div className="c-list-item" key={index}>
                            <div
                                className="c-thumbnail--square c-modal_toggle"
                                style={{ width: "100%", height: "64px" }}
                                data-button_pos="bl"
                                data-object_fit="contain"
                                data-image-index={index % 2}
                                data-modal-target={`taste_images_modal_${props.taste.id}`}
                                onClick={() => {
                                    if (onClickThumbnail) {
                                        onClickThumbnail(index + 1);
                                    }
                                }}
                            >
                                <img src={u} alt="" />
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

const TasteCoverThumbnails = (props: AllProps) => {
    const { onClickThumbnail } = props;
    return (
        <div className="c-group--taste_details-thumb_list">
            <div className="c-list--equal" data-list_column="4">
                {props.taste.images.length > 0 &&
                    props.taste.images.slice(1).map((url, index) => {
                        const u = encodeURI(url);
                        return (
                            <div className="c-list-item" key={index}>
                                <div
                                    className="c-thumbnail--square c-modal_toggle"
                                    style={{ width: "100%", height: "64px" }}
                                    data-button_pos="bl"
                                    data-object_fit="contain"
                                    data-image-index={index % 2}
                                    data-modal-target={`taste_images_modal_${props.taste.id}`}
                                    onClick={() => {
                                        if (onClickThumbnail) {
                                            onClickThumbnail(index + 1);
                                        }
                                    }}
                                >
                                    <img src={u} alt="" />
                                </div>
                            </div>
                        );
                    })}
            </div>
        </div>
    );
};
export const TasteImageModal = (props: ITasteImageModal) => {
    return (
        <React.Fragment>
            <TasteImages
                taste_id={props.taste_id}
                urls={props.urls}
                startIndex={props.startIndex}
            />
        </React.Fragment>
    );
};
export default withRouter(TasteCell);
